<template>
  <tk-hotel-modal :click-to-close="true" @closed="$emit('close')">
    <section id="modalNumber" class="hotelModal">
      <tk-link class="modalBg" @click="$emit('close')"></tk-link>

      <div class="modalHeader roomInput">
        <tk-link class="modalBack" @click="$emit('close')">
          <tk-svg-icon class="icoBack" icon="prev" />
          戻る
        </tk-link>
      </div>

      <div class="hotelNumber">
        <div class="hotelNumberBox">
          <div class="hotelNumberLeft">
            <room-num-input
              v-model="roomNumber"
              :max-room-count="maxRoomCount"
            />
          </div>

          <div class="hotelNumberRight">
            <passenger-input
              v-for="(roomTraveller, idx) in roomTravellers"
              :key="`room${idx}`"
              :room-idx="idx"
              :room-traveller="roomTraveller"
              :max-persons="maxPersons"
              :max-child-age="maxChildAge"
              @change-room-traveller="onChangeRoomTraveller"
            />
          </div>
        </div>

        <div class="hotelNumberBtn">
          <tk-link class="hotelBtn" @click="selected">設定する</tk-link>
        </div>
      </div>
    </section>
  </tk-hotel-modal>
</template>

<script>
import TkSvgIcon from '../../atoms/TkIcon/TkSvgIcon.vue'
import TkLink from '../../atoms/TkLink/TkLink'
import TkHotelModal from '../../atoms/TkGlobalModal/TkHotelModal'
import RoomNumInput from './RoomNumInput'
import PassengerInput from './PassengerInput'

const MAX_ROOM_COUNT = 5
const MAX_PERSONS = 9
const MAX_CHILD_AGE = 11

export default {
  name: 'TkRoomInputModal',
  components: { TkLink, RoomNumInput, PassengerInput, TkHotelModal, TkSvgIcon },
  props: {
    initRoomTravellers: {
      type: Array,
      default() {
        return [
          {
            adultNumber: 1,
            childNumber: 0,
            childAges: [],
          },
        ]
      },
    },
    maxRoomCount: {
      type: Number,
      default: MAX_ROOM_COUNT,
    },
    maxPersons: {
      type: Number,
      default: MAX_PERSONS,
    },
    maxChildAge: {
      type: Number,
      default: MAX_CHILD_AGE,
    },
  },
  data() {
    return {
      roomNumber: this.initRoomTravellers.length,
      roomTravellers: this.initRoomTravellers,
    }
  },
  watch: {
    roomNumber() {
      const roomConditons = []
      for (let n = 0; n < this.roomNumber; n++) {
        const defaultCondition = {
          adultNumber: 1,
          childNumber: 0,
          childAges: [],
        }
        const roomConditon = this.roomTravellers[n] || defaultCondition
        roomConditons.push(roomConditon)
      }
      this.roomTravellers = roomConditons
    },
  },
  methods: {
    onChangeRoomTraveller({ condition, roomIdx }) {
      const roomTravellers = Array.from(this.roomTravellers)
      roomTravellers[roomIdx] = condition
      this.roomTravellers = roomTravellers
    },
    selected() {
      this.$emit('room-selected', this.roomTravellers)
    },
  },
}
</script>

<style lang="scss">
@import '~@ota-frontend/ui/src/scss/components/TkRoomInputModal.scss';
</style>
